import * as Yup from 'yup'

const buildSignUpSchema = (requiresBirthDate: boolean) =>
  Yup.object().shape({
    // step 1
    password: Yup.string()
      .min(8, 'ContraseÃ±a muy corta')
      .max(50, 'ContraseÃ±a demasiado larga')
      .required('La contraseÃ±a es requerida')
      .matches(/^(?=.*[A-Z]).+$/, 'La contraseÃ±a debe contener al menos una mayÃºscula')
      .matches(/^(?=.*[a-z]).+$/, 'La contraseÃ±a debe contener al menos una minÃºscula')
      .matches(/[!#$%&*-@?_~]/, 'La contraseÃ±a debe contener al menos un carÃ¡cter especial'),
    confirmPassword: Yup.string()
      .oneOf([Yup.ref('password'), null], 'Las contraseÃ±as ingresadas no coinciden')
      .min(8, 'Muy corta')
      .max(50, 'ContraseÃ±a demasiado larga')
      .required('Este campo es requerido'),
    // step 2: validaciÃ³n condicional
    documentType: Yup.string().when('validateDocument', {
      is: true,
      then: Yup.string().required('Este campo es requerido'),
    }),
    documentNumber: Yup.string().when('validateDocument', {
      is: true,
      then: Yup.string()
        .required('Este campo es requerido')
        .min(6, 'Muy corto')
        .max(50, 'Demasiado largo')
        .test('document-format', 'Formato de documento incorrecto', function (value) {
          if (typeof value !== 'string') {
            return false
          }

          const documentType = this.parent.documentType
          if (documentType === '3') {
            return /^[a-zA-Z0-9]+$/.test(value)
          }

          if (!/^\d+$/.test(value)) {
            return this.createError({ message: 'El documento debe contener solo nÃºmeros' })
          }

          return true
        }),
    }),
    // step 3
    firstName: Yup.string().min(2, 'Muy corto!').max(50, 'Muy largo!').required('Required'),
    lastName: Yup.string().min(2, 'Muy corto!').max(50, 'Muy largo!').required('Required'),
    birthDate: requiresBirthDate ? Yup.string().required('Este campo es requerido') : Yup.string().notRequired(),
  })

export const getSignUpSchema = (requiresBirthDate: boolean) => buildSignUpSchema(requiresBirthDate)

export const SignUpSchema = buildSignUpSchema(true)

export interface IItemValidate {
  text: string
  validate: boolean
  token?: string
}

export type ISubmit = {
  password: string
  confirmPassword: string
  documentType: string
  documentNumber: string
  firstName: string
  lastName: string
  birthDate: string
}

export type IDefaultValues = {
  firstName: string
  lastName: string
  role: string
}

export interface IProps {
  onSubmit: (values: ISubmit) => void
  defaultValues?: IDefaultValues
  personId: number
  token: string
  storedDocument: string
  requireDocument?: boolean
  requireBirthDate?: boolean
}
